import React from "react";
import McuHeader from "./Components/Layout/McuHeader";
import McuFooter from "./Components/Layout/McuFooter";
import Configurator from "./pages/Configurator";
import BadgeWidget from "./Components/ConfigurationsSteps/BadgeWidget";
import InfoBar from "./Components/ConfigurationsSteps/InfoBar";
import {
  createTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";
import "./css/App.css";
import "./css/header-footer-custom.css";

const theme = responsiveFontSizes(
  createTheme({
    cssVariables: true,
    palette: {
      mode: "light",
      primary: {
        main: "#3f51b5",
      },
      secondary: {
        main: "#f50057",
      },
      custom: {
        btnBackground: "#007ac3",
        ttcPrice: "#007ac3",
        blue: "#007ac3",
      },
    },
    typography: {
      fontFamily: [
        "Montserrat",
        "Helvetica",
        "Arial",
        "Lucida",
        "sans-serif",
      ].join(","),
      h3: {
        color: "#007ac3",
        fontSize: "22px",
        fontWeight: "700",
        paddingBottom: "30px",
      },
    },
  }),
);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <McuHeader />
      <Configurator />
      <BadgeWidget />
      <InfoBar />
      <McuFooter />
    </ThemeProvider>
  );
};

export default App;
